<div class="modal-header">
    <h5 class="pt-4 ps-4">Editar Registro</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography">
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field color="accent" class="w-100">
                        <mat-label>Estatus</mat-label>
                        <mat-select [(ngModel)]="data.estatus">
                          <mat-option value="order_completed">Recolectado</mat-option>
                          <mat-option value="assigned">En tránsito</mat-option>
                          <mat-option value="started">En ruta de entrega</mat-option>
                          <mat-option value="successful">Entregado</mat-option>
                          <mat-option value="canceled">Cancelado</mat-option>
                          <mat-option value="incident">Incidencia</mat-option>
                          <mat-option value="pending">Pendiente</mat-option>
                          <mat-option value="order_created">Esperando recolección</mat-option>
                          <mat-option value="return">Devolución</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field color="accent" class="w-100">
                        <mat-label>Fecha Entrega</mat-label>
                        <input matInput [matDatepicker]="picker" [(ngModel)]="data.fecha_entrega " >
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" >
                <div class="col-md-6">
                    <mat-form-field color="accent" class="w-100">
                        <mat-label>Paquetería</mat-label>
                        <mat-select [(ngModel)]="data.paqueteria">
                          <mat-option value="AFIMEX">AFIMEX</mat-option>
                          <mat-option value="ESTAFETA">ESTAFETA</mat-option>
                          <mat-option value="DHL">DHL</mat-option>
                          <mat-option value="FEDEX">FEDEX</mat-option>
                          <mat-option value="LOCAL">LOCAL</mat-option>
                          <mat-option value="PAQUETEXPRESS">PAQUETEXPRESS</mat-option>
                          <mat-option value="PEX">PEX</mat-option>
                          <mat-option value="99MINUTOS">99MINUTOS</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field color="accent" class="w-100">
                        <mat-label>Tracking Number</mat-label>
                        <input matInput [(ngModel)]="data.tracking_number " >
                    </mat-form-field>
                </div>
            </div>
            
    

        </div>
        
    </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: flex-end;" class="me-4">
    <button mat-flat-button class="bg-success text-white" type="button" (click)="editTracking(inputData)">Guardar <mat-icon>save</mat-icon></button>
</mat-dialog-actions>